var _excluded = ["capture", "children", "onClickOutside", "className", "data-qa"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { useCallback, useEffect, useRef } from "react";
import { useBox } from "@ati/hooks";
function OuterClickListener(_ref) {
  var {
      capture = false,
      children,
      onClickOutside,
      className,
      "data-qa": dataQa = "outer-click-listener"
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var element = useRef(null);
  var onClickOutsideBox = useBox(onClickOutside);
  var handleDocumentClick = useCallback(event => {
    if (event.target instanceof Node && element.current && !element.current.contains(event.target)) {
      onClickOutsideBox.current(event);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("click", handleDocumentClick, {
      capture
    });
    return () => {
      document.removeEventListener("click", handleDocumentClick, {
        capture
      });
    };
  }, [capture]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    "data-qa": dataQa,
    ref: element
  }, rest), children);
}
export default OuterClickListener;